package com.merkost.handpass.admin.util

import io.ktor.client.plugins.HttpRequestTimeoutException
import io.ktor.client.plugins.ResponseException
import io.ktor.http.HttpStatusCode

fun Throwable.toAdminMessage(): String = when (this) {
    is HttpRequestTimeoutException ->
        "The request timed out. Check your connection and try again."

    is ResponseException -> when (response.status) {
        HttpStatusCode.Unauthorized -> "Your session expired. Please sign in again."
        HttpStatusCode.Forbidden -> "You don't have permission to do that."
        HttpStatusCode.NotFound -> "We couldn't find what you were looking for."
        HttpStatusCode.TooManyRequests -> "Too many requests. Wait a moment and try again."
        else -> if (response.status.value >= 500)
            "The server ran into a problem. Please try again shortly."
        else "Something went wrong. Please try again."
    }

    else -> {
        val raw = message.orEmpty()
        when {
            raw.contains("fetch", ignoreCase = true) ->
                "Can't reach the server. Check your connection and try again."

            raw.contains("NoTransformationFound", ignoreCase = true) ||
                raw.contains("Serializer", ignoreCase = true) ->
                "Something went wrong loading this data. Please try again."

            else -> "Something went wrong. Please try again."
        }
    }
}
